import { createContext, useContext } from "react"
import type { User } from "@/types/api"

export interface AvailableTenant {
  id: string
  name: string
  slug: string
  role: string
  created_at: string
  /** Organisme résilié ; absent des listes enregistrées avant ce champ. */
  closed: boolean
}

export interface AuthContextType {
  user: User | null
  isAuthenticated: boolean
  isLoading: boolean
  availableTenants: AvailableTenant[]
  login: (email: string, password: string) => Promise<void>
  logout: () => Promise<void>
  switchTenant: (tenant: AvailableTenant) => Promise<void>
}

export const AuthContext = createContext<AuthContextType | null>(null)

export function useAuth(): AuthContextType {
  const context = useContext(AuthContext)
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider")
  }
  return context
}
